/*
 * authReducer.js
 * trt_cms2
 *
 * Created by Hisyam on 27/2/2020.
 * Copyright (c) 2020 Terato Tech. All rights reserved.
 */

import {
  AUTH_ERROR, LOGIN,
  LOGIN_FAIL,
  LOGIN_SUCCESS,
  LOGOUT_SUCCESS, REGISTER_FAIL,
  REGISTER_SUCCESS,
  USER_LOADED,
  USER_LOADING
} from "../types";

const initialState = {
  "errors": {},
  "token": localStorage.getItem("token"),
  "isAuthenticated": null,
  "isLoading": true,
  "user": {
    "username": null,
    "email": null
  }
};

export default function (state = initialState, action) {
  switch (action.type) {
    case USER_LOADING:
    case LOGIN:
      return {
        ...state,
        isLoading: true
      };
    case USER_LOADED:
      return {
        ...state,
        isAuthenticated: true,
        isLoading: false,
        user: action.payload
      };
    case LOGIN_SUCCESS:
    case REGISTER_SUCCESS:
      localStorage.setItem("token", action.payload.token);
      return {
        ...state,
        ...action.payload,
        isAuthenticated: true,
        isLoading: false
      };

    case LOGIN_FAIL:
    case AUTH_ERROR:
    case LOGOUT_SUCCESS:
    case REGISTER_FAIL:
      localStorage.removeItem("token");
      return {
        ...state,
        token: null,
        user: initialState.user,
        isAuthenticated: false,
        isLoading: false,
        errors: action.payload?.response ?? {},
      };
    default:
      return state;
  }
}